import {Typography, useTheme } from "@mui/material";

type ChipStateProps = {
  state?: boolean;
};
export const ChipState = ({ state }: ChipStateProps) => {
  const theme = useTheme();
  return (
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: 13,
        textTransform: "uppercase",
        transition: "background 0.8s ease",
        color: state ? theme.palette.success.main : theme.palette.warning.main,
      }}
    >
      {state ? "In Stock" : "Sold Out"}
    </Typography>
  );
};
